import { createFeatureSelector, createSelector } from '@ngrx/store';
import { LOCATION_FEATURE } from '../actions/location.actions';
import { LocationState } from '../reducers/location.reducer';

const featureSelector = createFeatureSelector<LocationState>(LOCATION_FEATURE);

export const selectLoading = createSelector(
  featureSelector,
  (state) => state?.loading
);

export const selectCities = createSelector(
  featureSelector,
  (state) => state?.cities
);
